import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import CreateChannelFirst from "../Create_channel_screen/CreateChannelFirst";
import "./create.css";
import axios from "../../../axios";

const Create = () => {
  const navigate = useNavigate();
  const [click, setClick] = useState(false);
  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const [status, setStatus] = useState(false);

  useEffect(() => {
    const getCommunity = async () => {
      try {
        let res = await axios.get(
          `/api/v1/community/getByUserId/teacher/${teacher_id}?_limit=1&_page=1`
        );
        res.data.data.length > 0
          ? navigate("/TotalCommuPost")
          : setStatus(true);
      } catch (error) {
        console.log(error);
      }
    };

    getCommunity();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return status ? (
    <>
      <div className="chanel_main_container">
        <div className="d-flex flex-column align-items-center">
          <span className="m-2 text-center create_description">
            No channels yet. Be the first one to create a channel for the
            community.
          </span>

          <button
            className="mt-2 btn px-4 py-2 create_button"
            onClick={(e) => setClick(true)}
          >
            Create Channel
          </button>
        </div>
      </div>
      {click && <CreateChannelFirst change={setClick} />}
    </>
  ) : (
    <>
      <img className="Loader" src="/gif/LoaderDot.gif" alt="" />
    </>
  );
};

export default Create;
